import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Persistent visitor id
export function getVisitorId() {
    try {
        let vid = localStorage.getItem("ciko_vid");
        if (!vid) {
            vid =
                (crypto?.randomUUID && crypto.randomUUID()) ||
                `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
            localStorage.setItem("ciko_vid", vid);
        }
        return vid;
    } catch (_e) {
        return `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
}

export async function trackVisit(path = "/") {
    try {
        await axios.post(`${API}/track/visit`, {
            visitor_id: getVisitorId(),
            path,
            referrer: document.referrer || "",
            user_agent: navigator.userAgent || "",
        });
    } catch (e) {
        // silent
    }
}

export async function trackClick(button_id, label) {
    // Fire Meta Pixel Subscribe event (best-effort, non-blocking)
    try {
        if (typeof window !== "undefined" && typeof window.fbq === "function") {
            window.fbq("track", "Lead", {
                content_name: label || button_id,
                content_category: "cta",
            });
        }
    } catch (_e) {
        /* silent */
    }
    try {
        await axios.post(`${API}/track/click`, {
            visitor_id: getVisitorId(),
            button_id,
            label,
        });
    } catch (e) {
        // silent
    }
}

export async function fetchAnalytics(dateFrom, dateTo) {
    const params = {};
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    const { data } = await axios.get(`${API}/analytics/summary`, { params });
    return data;
}
